import api from './client';

export interface AiCostsDayRow {
  day: string; // ISO yyyy-MM-dd
  costUsd: number;
  calls: number;
  tokens: number;
}

export interface AiCostsGroupRow {
  key: string; // feature albo NIP ("—" gdy brak)
  costUsd: number;
  calls: number;
  tokens: number;
}

export interface AiCosts {
  totalCostUsd: number;
  totalCalls: number;
  totalPromptTokens: number;
  totalCompletionTokens: number;
  byDay: AiCostsDayRow[];
  byFeature: AiCostsGroupRow[];
  byNip: AiCostsGroupRow[];
}

export const aiCostsApi = {
  get: (params: { nip?: string; from?: string; to?: string }) =>
    api.get<AiCosts>('/api/admin/ai-costs', { params }),
};
